import { render, staticRenderFns } from "./PelletsPriceCard.vue?vue&type=template&id=3b37c4e4&scoped=true"
import script from "./PelletsPriceCard.vue?vue&type=script&lang=ts"
export * from "./PelletsPriceCard.vue?vue&type=script&lang=ts"
import style0 from "./PelletsPriceCard.vue?vue&type=style&index=0&id=3b37c4e4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b37c4e4",
  null
  
)

export default component.exports